import React, { useEffect, useRef, useState } from 'react';

interface IdleTimerProps {
  timeout: number;
  onIdle: () => void;
}

const IdleTimer: React.FC<IdleTimerProps> = ({ timeout, onIdle }) => {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef<number | null>(null);

  // Reset the timer
  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setIsIdle(false);
    timerRef.current = window.setTimeout(() => {
      setIsIdle(true);
      onIdle();
    }, timeout);
  };

  // Add event listeners for user interactions
  useEffect(() => {
    const handleActivity = () => {
      resetTimer();
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('click', handleActivity);
    window.addEventListener('keydown', handleActivity);

    // Initialize the timer
    resetTimer();

    // Clean up event listeners and timer on component unmount
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, []);

  // useEffect(()=>{
  //   console.log('IdleTimer timeout changed', timeout);
  // },[timeout])

  return null; // This component does not render anything
};

export default IdleTimer;
